import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const PublicQuestions = ({ questions }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  // //console.log(questions);

  return (
    <div className="flex justify-center font-sans mt-3 mb-5">
      <div className="p-5 w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg ">
        <div className="text-[20px] font-semibold mb-5 underline">
          Questions asked by others
        </div>
        <Carousel
          responsive={responsive}
          infinite={true}
          showDots={true}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          transitionDuration={2000}
        >
          {questions.map((item, index) => {
            return (
              <div className="flex justify-center mb-8">
                <div className="bg-white rounded-lg  h-auto w-[350px] overflow-hidden shadow-lg border-[1px]">
                  <div className="p-4 flex flex-col justify-between ">
                    <div className="flex flex-row">
                      <div className="mx-2 scale-[1]">
                        <i class="fa-solid fa-user-circle"></i>
                      </div>

                      <div className="font-semibold text-[16px]">
                        {item.question}
                      </div>
                    </div>
                    <div className="flex flex-row my-4">
                      <div className="mx-2 scale-[1]">
                        <i class="fa-solid fa-comments"></i>
                      </div>

                      <div className="text-[16px]">{item.answer}</div>
                    </div>
                    <div className="mx-2 mt-10 text-[14px] text-gray-600">
                      Answered on {item.date}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
        <div className="flex flex-row ml-10">
          <div className="flex justify-center w-[200px]">
            <button className="bg-none hover:scale-[1.05] text-black py-2 w-full  text-[13px] font-semibold rounded-xl border-2 border-black transition-all">
              Ask a question
            </button>
          </div>
          {/* <div className="flex justify-center w-[200px] ml-3">
            <button className="bg-none hover:scale-[1.05] text-black py-2 w-full  text-[13px] font-semibold rounded-xl border-2 border-black transition-all">
              Show more questions
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PublicQuestions;
